import API from "api.js";
import { store } from "store";
import { setUser, setSub } from "action";

/**
 * Refreshes the logged-in user's subscription info in Redux so UI updates immediately
 * (sidebar, transaction page, gated routes, chatbot, etc.).
 *
 * Source of truth: GET dashboard_data -> res.data.data.subscription
 */
export async function refreshUserSubscriptions(dispatch) {
  try {
    const res = await API({
      url: "dashboard_data",
      method: "GET",
      handlerEnabled: false,
    });

    const subscription = res?.data?.data?.subscription;
    if (!subscription) return null;

    const currentUser = store.getState().user || {};
    const updatedUser = { ...currentUser, active_subscription: subscription };
    dispatch(setUser(updatedUser));

    const isSubscribed = Array.isArray(subscription) && subscription.length > 0;
    dispatch(setSub(isSubscribed));
    
    return subscription;
  } catch (e) {
    // non-fatal: we still want to show the success UI even if refresh fails
    return null;
  }
}

